import React from 'react'
import styles from './styles.css'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import Image from './Image'

export default class Signature extends React.Component {
  static propTypes = {
    me: PropTypes.func,
    value: PropTypes.string,
    onChange: PropTypes.func,
    field: PropTypes.object
  }

  @autobind
  async setSignature() {
    if (global.selSignatureId !== '') {
      const signatureId = global.selSignatureId
      await this.props.onChange(signatureId)
      console.warn('setSignature: ', signatureId, 'is set')
    } else {
      console.error('Impossible to get selected signature')
    }
  }
  async getSignature() {
    global.onCloseSignature.push(this.setSignature)
    const signatureId = await global.getSelSignature()
    return signatureId
  }

  renderClassName() {
    if (this.props.field.required) {
      return styles.requiredSign
    }
    return styles.noRequiredSign
  }

  render() {
    let required = '(Opcional)'
    if (this.props.field && this.props.field.required) {
      required = '(Requerido)'
    }
    return (
      <div
        id={this.props.field.id}
        className={this.renderClassName()}
        onClick={() => this.getSignature()}
        data-filled={this.props.value ? 'true' : 'false'}
        data-filler={this.props.field && this.props.field.filler}
        data-required={this.props.field && this.props.field.required ? 'true' : 'false'}
      >
        {this.props.value ? <Image signatureId={this.props.value} /> : `Firmar ${required}`}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/Field/Edit/Signature/index.js